import Area from '@/components/Area';
import { GizmoHelper, GizmoViewport, OrbitControls } from '@react-three/drei';
import { Canvas, extend, ThreeToJSXElements } from '@react-three/fiber';
import * as React from 'react';
import * as THREE from 'three/webgpu';
import * as TSL from 'three/tsl';
import { TslDebugProvider, TslDebugViewer, TslDebug } from '@/components/TslDebug';

declare module '@react-three/fiber' {
  interface ThreeElements extends ThreeToJSXElements<typeof THREE> {}
}

extend(THREE as any);

function Main() {
  // const fragmentNode = React.useMemo(() => TSL.positionLocal), []);

  return (
    <Canvas
      camera={{ position: [0, 0, 1.8] }}
      gl={async (props) => {
        const renderer = new THREE.WebGPURenderer(props as any);
        renderer['capabilities'] = {
          getMaxAnisotropy() {
            return 0;
          },
        };
        await renderer.init();
        return renderer;
      }}
    >
      <ambientLight />
      <pointLight position={[10, 10, 10]} />
      <group>
        <mesh name="node-mesh">
          <boxGeometry args={[1, 1, 1]} />
          <nodeMaterial fragmentNode={TSL.positionLocal} />
          <TslDebug meshName={'node-mesh'} />
        </mesh>
      </group>
      <OrbitControls enableZoom={false} />
      <gridHelper args={[10, 10]} />
      <GizmoHelper alignment="bottom-right" margin={[80, 80]}>
        <GizmoViewport axisColors={['red', 'green', 'blue']} labelColor="black" />
      </GizmoHelper>
    </Canvas>
  );
}

export type Props = {};

function App01(props: Props) {
  const {} = props;

  return (
    <TslDebugProvider>
      <Area>{() => <Main />}</Area>
      <TslDebugViewer showVertexShader showFragmentShader />
    </TslDebugProvider>
  );
}

export default React.memo(App01);
